import React from 'react'
import { MenuItem, TextField, InputAdornment } from '@mui/material'
import { DateRange } from '@mui/icons-material'

import { dateRangeOptions, type DateRangeOption } from './Helper'

type DateRangeSelectorProps = {
  selectedDateRangeAsString: string
  onRangeOptionSelect: (selectedRangeOption: DateRangeOption) => void
  disabled: boolean
}

const DateRangeSelector = React.forwardRef<
  HTMLDivElement,
  DateRangeSelectorProps
>(function DateRangeSelector(
  { selectedDateRangeAsString, onRangeOptionSelect, disabled },
  ref,
) {
  return (
    <TextField
      select
      ref={ref}
      size="small"
      disabled={disabled}
      sx={{
        minWidth: 260,
        '.MuiOutlinedInput-root': {
          paddingLeft: 0,

          '.MuiInputAdornment-root': {
            position: 'absolute',
            padding: '14px',
          },

          '.MuiSelect-select': {
            paddingLeft: '46px',
          },
        },
      }}
      value={selectedDateRangeAsString}
      label="Date range"
      inputProps={{ 'data-testid': 'daterange-input' }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ position: 'absolute' }}>
            <DateRange />
          </InputAdornment>
        ),
      }}
      onChange={(e) => onRangeOptionSelect(e.target.value as DateRangeOption)}
    >
      {dateRangeOptions.map(({ label, value }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
      <MenuItem
        selected={true}
        sx={{ display: 'none' }}
        value={selectedDateRangeAsString}
      >
        {selectedDateRangeAsString}
      </MenuItem>
    </TextField>
  )
})

export default DateRangeSelector
